import { render, staticRenderFns } from "./VueComponenteMenuPage.vue?vue&type=template&id=66c0031a"
import script from "./VueComponenteMenuPage.vue?vue&type=script&lang=js"
export * from "./VueComponenteMenuPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports